import { render, staticRenderFns } from "./PostCreation.vue?vue&type=template&id=5dec25d2&scoped=true"
import script from "./PostCreation.vue?vue&type=script&lang=js"
export * from "./PostCreation.vue?vue&type=script&lang=js"
import style0 from "./PostCreation.vue?vue&type=style&index=0&id=5dec25d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dec25d2",
  null
  
)

export default component.exports